import { Link } from 'react-router-dom';
import { INSTAGRAM_PROFILE_URL, TEL_HREF, WHATSAPP_CHAT_URL } from '../../../config/contactLinks';

const logoSrc = `${import.meta.env.BASE_URL}lyeni.png`;
import eLogo from '../../../assets/images/elogo.avif';

const quickLinks = [
  { label: 'Ana Sayfa', href: '/' },
  { label: 'Hizmetler', href: '/hizmetler' },
  { label: 'Hakkımızda', href: '/hakkimizda' },
  { label: 'Referanslar', href: '/referanslar' },
  { label: 'İletişim', href: '/iletisim' },
  { label: 'SSS', href: '/sss' },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy-dark text-white">
      {/* CTA Banner */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-gold text-xs font-bold uppercase tracking-[0.2em] mb-2">Hemen Başlayalım</p>
            <h3 className="text-2xl md:text-3xl font-extrabold text-white tracking-tight">
              Ücretsiz keşif ve fiyat teklifi için<br className="hidden md:block" /> bugün bize ulaşın.
            </h3>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <a href={WHATSAPP_CHAT_URL} target="_blank" rel="nofollow noreferrer"
              className="flex items-center gap-2 bg-gold hover:bg-gold-dark text-white font-bold px-6 py-3.5 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-whatsapp-line text-base"></i>
              WhatsApp&apos;tan Yaz
            </a>
            <a href={TEL_HREF}
              className="flex items-center gap-2 border border-white/20 hover:border-gold text-white hover:text-gold font-bold px-6 py-3.5 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line text-base"></i>
              0543 191 0851
            </a>
          </div>
        </div>
      </div>

      {/* Main footer — 3 sütun */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">

          {/* Brand */}
          <div>
            <img src={logoSrc}
              alt="NiğPak Temizlik"
              className="block max-h-48 sm:max-h-56 md:max-h-64 lg:max-h-72 w-auto max-w-full object-contain object-left mb-5"
            />
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              Niğde&apos;nin güvenilir profesyonel temizlik şirketi. Kaliteli hizmet, deneyimli ekip.
            </p>
            <div className="flex items-center gap-2.5">
              {[
                { icon: 'ri-whatsapp-line', href: WHATSAPP_CHAT_URL },
                { icon: 'ri-instagram-line', href: INSTAGRAM_PROFILE_URL },
                { icon: 'ri-mail-line', href: 'mailto:nigpaktemizlik@gmail.com' },
              ].map(s => (
                <a key={s.icon} href={s.href} target={s.href.startsWith('http') ? '_blank' : undefined}
                  rel={s.href.startsWith('http') ? 'nofollow noreferrer' : undefined}
                  className="w-9 h-9 flex items-center justify-center border border-white/15 hover:border-gold hover:text-gold rounded-lg text-base text-white/60 transition-colors cursor-pointer">
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <p className="text-white text-xs font-bold uppercase tracking-[0.2em] mb-5">Sayfalar</p>
            <ul className="space-y-3">
              {quickLinks.map(l => (
                <li key={l.href}>
                  <Link to={l.href}
                    className="text-white/55 hover:text-gold text-sm transition-colors cursor-pointer flex items-center gap-2">
                    <i className="ri-arrow-right-s-line text-gold/60 text-sm"></i>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-white text-xs font-bold uppercase tracking-[0.2em] mb-5">İletişim</p>
            <ul className="space-y-4">
              {[
                { icon: 'ri-whatsapp-line', label: '0543 191 0851', sub: 'WhatsApp', href: WHATSAPP_CHAT_URL, color: 'text-gold' },
                { icon: 'ri-instagram-line', label: 'nigpak.temizlik', sub: 'Instagram', href: INSTAGRAM_PROFILE_URL, color: 'text-white/70' },
                { icon: 'ri-mail-line', label: 'nigpaktemizlik@gmail.com', sub: 'E-Posta', href: 'mailto:nigpaktemizlik@gmail.com', color: 'text-white/70' },
                { icon: 'ri-map-pin-line', label: 'Niğde Merkez', sub: 'Konum', href: null, color: 'text-white/70' },
              ].map(c => {
                const inner = (
                  <div className="flex items-start gap-3">
                    <span className="w-7 h-7 flex items-center justify-center border border-white/10 rounded-lg shrink-0 mt-0.5">
                      <i className={`${c.icon} text-sm text-white/50`}></i>
                    </span>
                    <div>
                      <p className="text-[10px] text-white/30 uppercase tracking-wider mb-0.5">{c.sub}</p>
                      <p className={`text-sm font-semibold ${c.color} break-all`}>{c.label}</p>
                    </div>
                  </div>
                );
                return c.href ? (
                  <li key={c.sub}>
                    <a href={c.href} target={c.href.startsWith('http') ? '_blank' : undefined}
                      rel={c.href.startsWith('http') ? 'nofollow noreferrer' : undefined}
                      className="cursor-pointer hover:opacity-80 transition-opacity block">
                      {inner}
                    </a>
                  </li>
                ) : <li key={c.sub}>{inner}</li>;
              })}
            </ul>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 h-12 flex items-center justify-between">
          <p className="text-white/30 text-[11px]">&copy; {currentYear} NiğPak Temizlik — Tüm hakları saklıdır.</p>
          <a
            href="https://epiked.com"
            rel="nofollow noreferrer"
            className="hidden sm:flex items-center gap-2 cursor-pointer"
          >
            <img src={eLogo} alt="Epiked" className="h-4 w-auto object-contain" />
            <p className="text-white/70 text-[11px]">Profesyonel web sistemleri ile hazırlanmıştır.</p>
          </a>
        </div>
      </div>
    </footer>
  );
}
